import React, { useEffect, useState } from "react";
import { axiosGetCall } from "src/services/apisCall";
import {
  Box,
  Typography,
  Grid,
  Paper,
  CircularProgress,
  Button,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

const UpcomingMeeting = () => {
  const [counts, setCounts] = useState({
    active: 0,
    upcoming: 0,
    closed: 0,
    total: 0,
    previous: 0,
  });
  const [loading, setLoading] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
  });

  const fetchCounts = async () => {
    setLoading(true);
    try {
      const payload = {
        startDate: dateRange.startDate
          ? dayjs(dateRange.startDate).format("YYYY-MM-DD")
          : "",
        endDate: dateRange.endDate
          ? dayjs(dateRange.endDate).format("YYYY-MM-DD")
          : "",
      };
      const response = await axiosGetCall("webinarCount", payload);
      setCounts(response?.result);
    } catch (err) {
      console.error("Error fetching webinar counts", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCounts();
    
  }, []);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ padding:"25px" }}>
        <Typography variant="h5" gutterBottom>
          Upcoming Meeting :
        </Typography>

        <Box sx={{ display: "flex", gap: 2, mb: 3, flexWrap: "wrap" }}>
          <DatePicker
            label="Start Date"
            value={dateRange.startDate}
            onChange={(newValue) =>
              setDateRange((prev) => ({ ...prev, startDate: newValue }))
            }
            slotProps={{
              textField: {
                size: "small",          
                sx: {
                  width: 140,           
                  ".MuiInputBase-input": { p: 1 }, 
                },
              },
            }}
          />

          <DatePicker
            label="End Date"
            value={dateRange.endDate}
            onChange={(newValue) =>
              setDateRange((prev) => ({ ...prev, endDate: newValue }))
            }
            minDate={dateRange.startDate}
            slotProps={{
              textField: {
                size: "small",
                sx: {
                  width: 140,
                  ".MuiInputBase-input": { p: 1 },
                  '& label': {
                    zIndex: 0, 
                  },
                },
              },
            }}
          />

          <Button
            variant="contained"
            onClick={fetchCounts}
            sx={{ alignSelf: "center", whiteSpace: "nowrap" }}
          >
            Apply Filter
          </Button>
        </Box>
               {loading ? (
          <Box sx={{ textAlign: "center" }}>
            <CircularProgress />
            <Typography variant="body1" mt={2}>
              fetching webinar summary...
            </Typography>
          </Box>
        ) : (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
              <Paper
                elevation={3}
                sx={{ p: 3, textAlign: "center", bgcolor: "#e3f2fd" }}
              >
                <Typography variant="subtitle1" color="text.secondary">
                  Upcoming
                </Typography>
                <Typography variant="h4" color="primary.main">
                  {counts.upcoming}
                </Typography>
              </Paper>
            </Grid>
           
          </Grid>
        )}
      </Box>
    </LocalizationProvider>
  );
};

export default UpcomingMeeting;
